import { useState } from "react";
import { Box, Grid, Button } from "@mui/material";
import WorkIcon from "@mui/icons-material/Work";
import { BaseModalComponent } from "../common/BaseModalComponent";
import { IndividualServices } from "../IndividualServices";
import { filledButton } from "../ui/styles/buttonStyles";
import { WidgetComponentMaps } from "../common/WidgetComponentMaps";
import { ManageServices } from "./ManageServices";

export const ServicesWidget = ({ swapyName = "servicesWidget", sx }) => {
  const [onChange, setOnChange] = useState(false);

  return (
    <WidgetComponentMaps
      swapyName={swapyName}
      title="Services you offer"
      description="Manage and review the residential and commercial services available for your business."
      icon={<WorkIcon />}
      sxProp={{
        ...sx,
        height: { xs: "65vh", md: "70vh", lg: "100%" },
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* Contenido principal */}
      <Grid
        container
        spacing={2}
        sx={{
          flex: 1,
          overflow: "auto",
        }}
      >
        <Grid item xs={12} sm={12} md={6}>
          <IndividualServices
            onChange={onChange}
            title="Residential"
            type="residential"
            sxStyle={{ height: "100%" }}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          <IndividualServices
            onChange={onChange}
            title="Commercial"
            type="commercial"
            sxStyle={{ height: "100%" }}
          />
        </Grid>
      </Grid>

      {/* Footer con botón */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          bgcolor: "transparent",
          alignItems: "center",
        }}
      >
        <BaseModalComponent
          modalKey="Organization-ManageServices-Business"
          modalLabel="Manage Services"
          sx={{
            width: { xs: "90%", sm: "80%", md: "100%", lg: "1600px" },
            height: { xs: "95%", sm: "90%", md: "100%", lg: "100%" },
          }}
          elementTrigger={
            <Button sx={filledButton}>
              Manage Services
            </Button>
          }
          onCloseTheme="color"
        >

          <ManageServices />
        </BaseModalComponent>
      </Box>
    </WidgetComponentMaps>
  );
};
